export const tests = [
  { name: "cosmetic_dentistry", label: "Cosmetic Dentistry" },
  { name: "custom_dentures", label: "Custom Dentures" },
  { name: "dental_bridges", label: "Dental Bridges" },
  { name: "dental_cleanings", label: "Dental Cleanings, Exams and X-Rays" },
  { name: "dental_crowns", label: "Dental Crowns" },
  { name: "dental_fillings", label: "Dental Fillings" },
  { name: "dental_implants", label: "Dental Implants" },
  { name: "dental_sealants", label: "Dental Sealants" },
  { name: "dental_veneers", label: "Dental Veneers" },
  { name: "fluoride_treatments", label: "Fluoride Treatments" },
  { name: "general_dentistry", label: "General Dentistry" },
  { name: "partial_dentures", label: "Partial Dentures" },
  { name: "sedation_dentistry", label: "Sedation Dentistry" },
  { name: "teeth_extraction", label: "Teeth Extraction" },
  { name: "teeth_whitening", label: "Teeth Whitening" },
];
